window.overlay = $('#overlay');
window.lingua  = $('#lingua').val();
